// M8.3 /v2/brand surface flag.
//
// Env var: VITE_BRAND_V2_ENABLED. Default OFF.
// Parser strictly `=== 'true'` per 2026-10-30 M7/M8 amendment §4
// per-surface flag contract. Anything else (undefined, 'false',
// 'TRUE', '1', 'yes', '') is treated as OFF — the strict comparison
// is the hard contract so a misconfigured env can't accidentally
// expose the merged surface.
//
// Flag OFF: the /v2/brand/* splat is NOT registered in App.tsx. The
//           catch-all RootRedirect sends an authenticated session to
//           /home, same fallback as any unknown path. The legacy
//           /brand route is unchanged.
//
// Flag ON:  /v2/brand/* renders the 5-tab surface. Legacy /brand still
//           renders the shipped BrandPage with every card (default
//           visibilityPreset='full'), so the two coexist during
//           staging burn-in. Removal of the legacy route is a
//           separate cleanup PR.

export function isBrandV2Enabled(): boolean {
  return import.meta.env.VITE_BRAND_V2_ENABLED === 'true';
}
